import React, {Component} from 'react'
import DatePicker, {registerLocale} from "react-datepicker";
import {$$} from '../../helpers/localization';
import PropTypes from "prop-types";
import bg from 'date-fns/locale/bg';
import sq from 'date-fns/locale/sq';
import enGB from 'date-fns/locale/en-GB';
import {connect} from "react-redux";

registerLocale('bg', bg)
registerLocale('sq', sq)
registerLocale('en', enGB)


class DateRangePicker extends Component {
    state = {
        startDate: this.props.startDate,
        endDate: this.props.endDate
    }

    constructor(props) {
        super(props);
    }

    /**
     * Check if the props have changed, if so update state.
     *
     * @param {object} prevProps the previous props object
     */
    componentDidUpdate(prevProps) {
        if (this.props.startDate !== prevProps.startDate && this.props.endDate !== prevProps.endDate) {
            this.setState({
                startDate: this.props.startDate,
                endDate: this.props.endDate
            });
        }
    }

    /**
     * Set the start date and trigger the range selection function
     *
     * @param {date} date the selected start date
     */
    setStartDate = (date) => {
        this.setState({
            startDate: date
        }, this.triggerRangeSelection);
    }

    /**
     * Set the end date and trigger the range selection function
     *
     * @param {date} date the selected end date
     */
    setEndDate = (date) => {
        this.setState({
            endDate: date
        }, this.triggerRangeSelection);
    }

    /**
     * Trigger range selected if both dates are set
     */
    triggerRangeSelection = () => {
        this.props.onRangeSelected(this.state);
    }

    render() {
        return (
            <div className="flex-container">
                <div>
                    <DatePicker
                        locale={this.props.i18n.selected.lang}
                        selected={this.state.startDate}
                        onChange={date => this.setStartDate(date)}
                        selectsStart
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        isClearable
                        dateFormat={this.props.settings.dateFormat}
                        placeholderText={$$('start_date')}
                        className="form-control"
                    />
                </div>
                <div className={"small-margin"}>
                <DatePicker
                        locale={this.props.i18n.selected.lang}
                        selected={this.state.endDate}
                        onChange={date => this.setEndDate(date)}
                        selectsEnd
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        minDate={this.state.startDate}
                        isClearable
                        dateFormat={this.props.settings.dateFormat}
                        placeholderText={$$('end_date')}
                        className="form-control"
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        settings: state.settings.data
    }
}


DateRangePicker.propTypes = {
    endDate: PropTypes.number,
    onRangeSelected: PropTypes.func,
    i18n: PropTypes.any,
    settings: PropTypes.any,
    startDate: PropTypes.number
};

export default connect(mapStateToProps, {})(DateRangePicker)